export interface ReviewsPageContent {
  hero: {
    backgroundImage: string
    title: string
    subtitle: string
  }
  trustpilotBusinessUnitId: string
  trustpilotCTA: string
}

const content: ReviewsPageContent = {
  hero: {
    backgroundImage: '/images/shipsticks/hero-background.jpg',
    title: "Thousands of golfers trust us. Here's why.",
    subtitle:
      'Read real reviews from customers who ditched the baggage claim and never looked back.',
  },
  trustpilotBusinessUnitId: '52fa33aa0000640005783427',
  trustpilotCTA: 'View all of ShipSticks real customer reviews on TrustPilot',
}

export default content
